import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabase';

function Home() {
  const [user, setUser] = useState(null);

  // Manage user session
  useEffect(() => {
    const fetchSession = async () => {
      const { data, error } = await supabase.auth.getSession();
      if (error) {
        console.error('Error fetching session:', error.message);
      } else if (data?.session?.user) {
        setUser(data.session.user);
      } else {
        setUser(null);
      }
    };

    fetchSession();

    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      if (session?.user) {
        setUser(session.user);
      } else {
        setUser(null);
      }
    });

    return () => {
      if (authListener && typeof authListener.unsubscribe === 'function') {
        authListener.unsubscribe();
      }
    };
  }, []);

  const signInWithGoogle = async () => {
    console.log('Current redirectTo:', window.location.origin);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.origin,
      },
    });
  
    if (error) console.error('Error signing in with Google:', error.message);
  };

  const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      console.error('Error signing out:', error.message);
    } else {
      setUser(null);
    }
  };

  return (
    <section className="hero is-fullheight is-dark">
      <div className="hero-body">
        <div className="container">
          {!user ? (
            <>
              <h1 className="title">Welcome, Traveler!</h1>
              <p className="subtitle">
                I’m Jerry, a Developer by Day, Dungeon Master by Night.
              </p>
              <button onClick={signInWithGoogle} className="button is-primary is-large">
                Sign in with Google
              </button>
            </>
          ) : (
            <>
              <h1 className="title">Welcome Back, {user.email}!</h1>
              <p className="subtitle">Let’s dive back into the adventure.</p>
              <div className="buttons">
                <Link to="/monsters" className="button is-primary is-large">
                  Monsters
                </Link>
                <button onClick={signOut} className="button is-light is-large">
                  Sign Out
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}

export default Home;
